var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 141,
    viewBox: "0 0 186 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 353"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    cx: 90.5387,
    cy: 64.6356,
    r: 64.6356,
    fill: "#FFDFD7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    cx: 90.5396,
    cy: 64.635,
    r: 50.5198,
    fill: "#FDE7D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M90.8752 128.358C84.9408 134.423 76.664 138.187 67.508 138.187C56.5793 138.187 46.9032 132.824 40.9678 124.586C38.038 132.526 30.403 138.187 21.4458 138.187C9.95706 138.187 0.643555 128.874 0.643555 117.385C0.643555 105.896 9.95706 96.5826 21.4458 96.5826C26.6443 96.5826 31.3973 98.4894 35.0438 101.642C36.9518 85.4053 50.7588 72.8086 67.508 72.8086C78.793 72.8086 88.7424 78.527 94.6166 87.2242C99.5076 83.3169 105.709 80.9809 112.456 80.9809C124.905 80.9809 135.496 88.9338 139.427 100.036C142.423 98.3118 145.898 97.3256 149.603 97.3256C160.48 97.3256 169.372 105.826 169.998 116.546C171.17 116.127 172.432 115.899 173.748 115.899C179.903 115.899 184.892 120.888 184.892 127.043C184.892 133.198 179.903 138.187 173.748 138.187C169.503 138.187 165.812 135.813 163.931 132.321C160.243 135.949 155.184 138.187 149.603 138.187C142.717 138.187 136.627 134.781 132.926 129.562C127.732 134.883 120.479 138.187 112.456 138.187C103.843 138.187 96.1191 134.38 90.8752 128.358Z",
    fill: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    d: "M184.892 127.043C184.892 120.888 179.903 115.899 173.748 115.899C172.432 115.899 171.17 116.127 169.998 116.546C169.371 105.826 160.48 97.3256 149.602 97.3256C145.897 97.3256 142.422 98.3118 139.426 100.036C135.496 88.9338 124.904 80.9809 112.455 80.9809C105.709 80.9809 99.5074 83.3169 94.6163 87.2242C88.7421 78.527 78.7927 72.8086 67.5077 72.8086C50.7586 72.8086 36.9515 85.4053 35.0435 101.642C31.3971 98.4894 26.644 96.5826 21.4456 96.5826C14.5461 96.5826 8.43115 99.9415 4.64673 105.113",
    stroke: "#F6552D",
    strokeWidth: 1.89827,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    cx: 117.082,
    cy: 33.4661,
    r: 2.22881,
    stroke: "#FB6D4A",
    strokeWidth: 3.08492
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    cx: 156.605,
    cy: 76.1617,
    r: 1.48588,
    stroke: "#FB6D4A",
    strokeWidth: 3.08492
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    cx: 25.9504,
    cy: 70.9409,
    r: 3.34322,
    stroke: "#FB6D4A",
    strokeWidth: 3.08492
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 24",
    d: "M59.3097 55.7198H51.9059M64.5359 49.3103V43.0898",
    stroke: "#F6552D",
    strokeWidth: 0.949136,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25",
    d: "M59.7456 50.6278L54.8209 45.7031",
    stroke: "#F6552D",
    strokeWidth: 0.949136,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    cx: 88.682,
    cy: 77.6376,
    r: 21.1737,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 28",
    x: 110.103,
    y: 89.2539,
    width: 37.9178,
    height: 14.8212,
    rx: 7.41059,
    transform: "rotate(45 110.103 89.2539)",
    fill: "#FF7C5C"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 88.8291,
    cy: 78.4601,
    r: 23.7049,
    transform: "rotate(45 88.8291 78.4601)",
    stroke: "#FF7C5C",
    strokeWidth: 6.64395
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    width: 17.8559,
    height: 3.07861,
    rx: 1.5393,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 96.231 83.6973)",
    fill: "#F6552D"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22_2",
    width: 17.8559,
    height: 3.0786,
    rx: 1.5393,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 94.0544 71.0713)",
    fill: "#F6552D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.0662 43.1952C90.1546 43.1377 89.369 43.8301 89.3115 44.7417C89.254 45.6533 89.9464 46.4389 90.858 46.4964C98.3671 46.97 105.737 50.0746 111.476 55.8129C115.587 59.9246 118.345 64.8718 119.753 70.1063C119.991 70.9884 120.898 71.511 121.78 71.2737C122.662 71.0364 123.185 70.129 122.948 69.2469C121.393 63.4678 118.347 58.0062 113.815 53.474C107.485 47.1447 99.3481 43.7175 91.0662 43.1952ZM85.029 46.1696C85.9424 46.1696 86.6829 45.4291 86.6829 44.5157C86.6829 43.6023 85.9424 42.8619 85.029 42.8619C84.1156 42.8619 83.3751 43.6023 83.3751 44.5157C83.3751 45.4291 84.1156 46.1696 85.029 46.1696Z",
    fill: "#F6552D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M112.132 97.793L129.002 114.663",
    stroke: "white",
    strokeWidth: 2.84741,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.ede44eb8f98a217323238b09a3183a1b.svg";
export { ForwardRef as ReactComponent };